module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8645/img/footerCmsFree.png"